export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Image de fond */}
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/972e8dcf8005bdff37194c729f906789/5cb0993a0911a36f1b9abbf4bd41d788.jpeg"
          alt="Cavalière en harmonie avec son cheval"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Contenu */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        {/* Barre d'information supérieure */}
        <div className="inline-flex items-center gap-3 bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full mb-12">
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-heart-pulse-line text-[#E8956F] text-lg"></i>
          </div>
          <span className="text-sm font-light text-gray-700">Formation Professionnelle • Sophrologie Cavaliers</span>
        </div>

        {/* Titre principal */}
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Endométriose &amp; Équitation
        </h1>

        {/* Sous-titre */}
        <p className="text-xl md:text-2xl text-white/95 font-light max-w-3xl mx-auto mb-12 leading-relaxed">
          Ne laissez plus la douleur vous priver de votre plein potentiel à cheval
        </p>

        {/* Boutons d'action */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <a 
            href="https://sophrocavaliers.learnybox.com/formation-endometriose-cavalieres/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-[#1A1A1A] text-white rounded-full text-base font-medium hover:bg-black transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Découvrir la Formation
          </a>
          <a 
            href="#solution"
            className="px-8 py-4 bg-white text-[#3D2817] rounded-full text-base font-medium hover:bg-gray-50 transition-all border-2 border-[#3D2817] whitespace-nowrap cursor-pointer"
          >
            En savoir plus
          </a>
        </div>
      </div>

      {/* Indicateur de scroll */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
